export const Lotties = {
  loading: require('./lotties/french-fries.json'),
  logoCry: require('./lotties/logoCry.png'),
  partyBot: require('./lotties/party-bot.json'),
}